<div class="content">
  <h1>{{ categoryName }}</h1>

  <p class="text">{{ description }}</p>

  <app-poi-list category="{{category}}"></app-poi-list>
</div>
